module.exports = __webpack_public_path__ + "static/media/fa-gavel.fdb63f7c.png";